import { render, staticRenderFns } from "./academic_course_detail.vue?vue&type=template&id=4014e50e&scoped=true"
import script from "./academic_course_detail.vue?vue&type=script&lang=js"
export * from "./academic_course_detail.vue?vue&type=script&lang=js"
import style0 from "./academic_course_detail.vue?vue&type=style&index=0&id=4014e50e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014e50e",
  null
  
)

export default component.exports